/**
 * Scripts for Admin Panel
 */

$(document).ready(function() {

	// Sortable
	var el = $('.sortable');
	for (var i=0; i<el.length; i++) {
		var sortable = Sortable.create(el[i]);
	}

	// Spectrum color picker
	$(".colorpicker").spectrum({
		// options here
	});

        var textarea    = $("#field-blurb");
    	textarea.attr('maxlength', '500');
        textarea.keydown(function(event) {
        	var numbOfchars = textarea.val();
            var len = numbOfchars.length;
            if(len<500){
			}else{
            	alert("You have reached the character limit for this field.")
			}
        });
    var formAction = $('#crudForm').attr('action');
        if($('crudForm')){
            if(formAction){
                if(formAction.includes('admin/news') || formAction.includes('admin/about/faq')){
                    $('#form-button-save').css( 'display','none');
                    $('#save-and-go-back-button').css('margin-left', '-10px');
                }

            }
        }


});
function insertAtCaret(areaId, text) {
    // $('.trumbowyg-editor').trumbowyg('execCmd', {
    //     cmd: 'insertText',
    //     param: 'text',
    //     forceCss: false,
    // {
    // console.log("this ");
		// var  cmd =
		// 	{
		// 		cmd: 'insertText',
		// 		val: 'text'
		// 	};
    //
    //     if (supported(cmd) === "btn-error") {
    //         alert("execCommand(“" + cmd.cmd + "”)\nis not supported in your browser");
    //         return;
    //     }
    //     val = (typeof cmd.val !== "undefined") ? prompt("Value for " + cmd.cmd + "?", cmd.val) : "";
    //     document.execCommand(cmd.cmd, false, (cmd.val || ""));
    // }
    // var txtarea = document.getElementById(areaId);
    // var txtarea = $('#content_input_box > div > div.trumbowyg-editor.trumbowyg-reset-css');
    // if (!txtarea) { return; }
    // console.log(text);
    // var scrollPos = txtarea.scrollTop;
    // var strPos = 0;
    // var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
    //     "ff" : (document.selection ? "ie" : false ) );
    // if (br == "ie") {
    //     txtarea.focus();
    //     var range = document.selection.createRange();
    //     range.moveStart ('character', -txtarea.value.length);
    //     strPos = range.text.length;
    // } else if (br == "ff") {
    //     strPos = txtarea.selectionStart;
    // }
    //
    // var front = (txtarea.value).substring(0, strPos);
    // var back = (txtarea.value).substring(strPos, txtarea.value.length);
    // txtarea.value = front + text + back;
    // strPos = strPos + text.length;
    // if (br == "ie") {
    //     txtarea.focus();
    //     var ieRange = document.selection.createRange();
    //     ieRange.moveStart ('character', -txtarea.value.length);
    //     ieRange.moveStart ('character', strPos);
    //     ieRange.moveEnd ('character', 0);
    //     ieRange.select();
    // } else if (br == "ff") {
    //     txtarea.selectionStart = strPos;
    //     txtarea.selectionEnd = strPos;
    //     txtarea.focus();
    // }
    //
    // txtarea.scrollTop = scrollPos;
}
function pasteHtmlAtCaret(html) {
    var sel, range;
    if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
            range = sel.getRangeAt(0);
            range.deleteContents();

            // Range.createContextualFragment() would be useful here but is
            // non-standard and not supported in all browsers (IE9, for one)
            var el = document.createElement("div");
            el.innerHTML = html;
            var frag = document.createDocumentFragment(), node, lastNode;
            while ( (node = el.firstChild) ) {
                lastNode = frag.appendChild(node);
            }
            range.insertNode(frag);

            // Preserve the selection
            if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    } else if (document.selection && document.selection.type != "Control") {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
    }
}